module.exports = require('../dist/components/Columns/Columns');
